<script>
import NewProductLine from "@/components/order/NewProductLine.vue";

export default {
  components: {
    NewProductLine
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      newVal: JSON.parse(JSON.stringify(this.value)),
      rules: {
        required: [
          v => !!v || "This field is required",
          v => !v || v.length > 0 || "Field must not be empty"
        ],
        paidBy: [
          v => !!v || "Paid by is required",
          v => !v || v.length > 0 || "Name must not be empty"
        ]
      }
    };
  },
  methods: {
    validate() {
      if (
        this.newVal.productId !== "" &&
        this.newVal.nkrCode !== "" &&
        this.$refs.form.validate()
      ) {
        return true;
      }
      this.$toast.open({
        message: `Please fill the form.`,
        type: "error",
        position: "top-right"
      });
      return false;
    },
    submitForm() {
      if (this.validate()) {
        this.$emit("submit", this.newVal);
      }
    },
    addProduct(product) {
      console.log("add product", product);
      this.newVal.nkrCode = product.nkrCode;
      this.newVal.line = product.line;
      this.newVal.productId = product.productId;
    },
    changeProduct() {
      this.newVal.nkrCode = "";
      this.newVal.productId = "";
      this.newVal.line = "";
    }
  }
};
</script>
<template>
  <div class="flex flex-col w-full">
    <BaseForm ref="form" @submit="submitForm" class="flex flex-col">
      <NewProductLine
        class="w-full"
        v-if="newVal.productId == ''"
        priceLevel="online"
        :edit="true"
        :products="[]"
        @addProduct="addProduct"
      ></NewProductLine>
      <div v-else>
        <p>NKR code: {{ newVal.nkrCode }}</p>
        <p>Product ID: {{ newVal.productId }}</p>
        <p>Line: {{ newVal.line }}</p>
        <button class="text-red-500" @click="changeProduct">
          Change product
        </button>
      </div>
      <BaseTextField
        label="Quantity per kit"
        v-model="newVal.quantity"
        type="number"
        step="1"
        required
      />
      <BaseSelectField
        v-model="newVal.priceType"
        :options="[
          {
            code: 'discount',
            name: 'Discount',
            comment: 'Reducing price from online'
          },
          {
            code: 'none',
            name: 'No discount',
            comment: 'No discount applied'
          },
          { code: 'fixed', name: 'Fixed', comment: 'Final price' }
        ]"
        label="Price type"
        required
      ></BaseSelectField>
      <BaseSelectField
        v-model="newVal.productDiscountType"
        :options="[
          {
            code: 'na',
            name: 'na',
            comment: 'No applicable'
          },
          {
            code: 'percentage',
            name: 'Percentage',
            comment: 'Percentage to discount from price'
          },
          {
            code: 'fixed',
            name: 'Fixed amount',
            comment: 'Reduce fixed amount'
          }
        ]"
        label="Discount type"
        required
      ></BaseSelectField>
      <BaseTextField
        label="Discount value, or fixed price"
        v-model="newVal.productDiscountValue"
        type="number"
        step="0.01"
      />
      <slot></slot>
    </BaseForm>
  </div>
</template>
